/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Lot_Size_SettingsInputs */

const vi_nav_lot_size_settings = /** @type {(inputs: Nav_Lot_Size_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Định mức lô`)
};

/**

* @param {Nav_Lot_Size_SettingsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const nav_lot_size_settings = /** @type {((inputs?: Nav_Lot_Size_SettingsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Lot_Size_SettingsInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_nav_lot_size_settings(inputs)
});